module.exports = __webpack_public_path__ + "static/media/renfo.caecbf30.jpg";